import { ObserversModule } from "@angular/cdk/observers";
import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { NgeMonacoModule } from "@cisstech/nge/monaco";
import { SmallstackTypeRegistry } from "@smallstack/typesystem";
import { DiffDisplayComponent } from "./components/diff-display/diff-display.component";
import { ImagePreviewComponent } from "./components/image-preview/image-preview.component";
import { MonacoEditorComponent } from "./components/monaco-editor/monaco-editor.component";
import { NiceObjectWrapperComponent } from "./components/nice-object-wrapper/nice-object-wrapper.component";
import { OverlayComponent } from "./components/overlay/overlay.component";
import { CorrectLinksDirective } from "./directives/correct-links.directive";
import { HighlightDirective } from "./directives/highlight.directive";
import { LoadingElementDirective } from "./directives/loading-element.directive";
import { SacAutofocusDirective } from "./directives/sac-autofocus.directive";
import { ScrollableDirective } from "./directives/scrollable.directive";
import { NgForTrackByIdDirective } from "./directives/track-by-id.directive";
import { NgForTrackByIndexDirective } from "./directives/track-by-index.directive";
import { NgForTrackByJsonDirective } from "./directives/track-by-json.directive";
import { CapitalizePipe } from "./pipes/capitalize.pipe";
import { ConvertToSubjectPipe } from "./pipes/convert-to-subject.pipe";
import { DecodeUriComponentPipe } from "./pipes/decode-uri-component.pipe";
import { FlattenPipe } from "./pipes/flatten.pipe";
import { HumanizeDurationPipe } from "./pipes/humanize-durations.pipe";
import { IsArrayPipe } from "./pipes/is-array.pipe";
import { JsonStringPipe } from "./pipes/json-string.pipe";
import { KeysPipe } from "./pipes/keys.pipe";
import { NonEmptyObjectPipe } from "./pipes/non-empty-object.pipe";
import { NonEmptyStringPipe } from "./pipes/non-empty-string.pipe";
import { RangePipe } from "./pipes/range.pipe";
import { SafePipe } from "./pipes/safe.pipe";
import { SortPipe } from "./pipes/sort.pipe";
import { SpaceBeforeCapPipe } from "./pipes/space-before-cap.pipe";
import { StringifyPipe } from "./pipes/stringify.pipe";
import { TextReplacerPipe } from "./pipes/text-replacer.pipe";
import { TimezonePipe } from "./pipes/timezone.pipe";
import { TranslatePipe } from "./pipes/translate.pipe";
import { UppercaseSpacePipe } from "./pipes/uppercase-space.pipe";
import { UrlConformPipe } from "./pipes/url-conform.pipe";
import { ValuesPipe } from "./pipes/values.pipe";
import { BreakpointService } from "./services/breakpoint.service";
import { DataTypeStore } from "./services/data-type.store";
import { DataStore } from "./services/data.store";
import { ErrorMessageHandler } from "./services/error-message-handler";
import { FrontendTypeRegistry } from "./services/frontend-type.registry";
import { RouterUtilService } from "./services/router-utils.service";
import { FrontendSchemaService } from "./services/frontend-schema.service";
import { ScrollTopService } from "./services/scroll-top.service";
import * as i0 from "@angular/core";
import * as i1 from "@cisstech/nge/monaco";
export class SmallstackCommonModule {
}
SmallstackCommonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: SmallstackCommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SmallstackCommonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.5", ngImport: i0, type: SmallstackCommonModule, declarations: [CapitalizePipe,
        ConvertToSubjectPipe,
        CorrectLinksDirective,
        DiffDisplayComponent,
        FlattenPipe,
        HumanizeDurationPipe,
        ImagePreviewComponent,
        JsonStringPipe,
        KeysPipe,
        LoadingElementDirective,
        SacAutofocusDirective,
        SafePipe,
        ScrollableDirective,
        SortPipe,
        SpaceBeforeCapPipe,
        StringifyPipe,
        TimezonePipe,
        UppercaseSpacePipe,
        UrlConformPipe,
        ValuesPipe,
        TranslatePipe,
        NiceObjectWrapperComponent,
        HighlightDirective,
        DecodeUriComponentPipe,
        NgForTrackByIdDirective,
        NgForTrackByIndexDirective,
        NgForTrackByJsonDirective,
        OverlayComponent,
        TextReplacerPipe,
        NonEmptyStringPipe,
        IsArrayPipe,
        NonEmptyObjectPipe,
        RangePipe,
        MonacoEditorComponent], imports: [CommonModule,
        FlexLayoutModule,
        MatButtonModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatDividerModule,
        FormsModule,
        ObserversModule,
        OverlayModule, i1.NgeMonacoModule], exports: [CapitalizePipe,
        ConvertToSubjectPipe,
        CorrectLinksDirective,
        DiffDisplayComponent,
        FlattenPipe,
        HumanizeDurationPipe,
        ImagePreviewComponent,
        JsonStringPipe,
        KeysPipe,
        LoadingElementDirective,
        SacAutofocusDirective,
        SafePipe,
        ScrollableDirective,
        SortPipe,
        SpaceBeforeCapPipe,
        StringifyPipe,
        TimezonePipe,
        UppercaseSpacePipe,
        UrlConformPipe,
        ValuesPipe,
        TranslatePipe,
        NiceObjectWrapperComponent,
        HighlightDirective,
        DecodeUriComponentPipe,
        NgForTrackByIdDirective,
        NgForTrackByIndexDirective,
        NgForTrackByJsonDirective,
        OverlayComponent,
        TextReplacerPipe,
        NonEmptyStringPipe,
        IsArrayPipe,
        NonEmptyObjectPipe,
        RangePipe,
        MonacoEditorComponent] });
SmallstackCommonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: SmallstackCommonModule, providers: [
        BreakpointService,
        DataStore,
        DataTypeStore,
        ErrorMessageHandler,
        FrontendTypeRegistry,
        { provide: SmallstackTypeRegistry, useExisting: FrontendTypeRegistry },
        RouterUtilService,
        FrontendSchemaService,
        ScrollTopService
    ], imports: [CommonModule,
        FlexLayoutModule,
        MatButtonModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatDividerModule,
        FormsModule,
        ObserversModule,
        OverlayModule,
        NgeMonacoModule.forRoot({ locale: "de", options: { scrollBeyondLastLine: true }, theming: { default: "vs-dark" } })] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: SmallstackCommonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FlexLayoutModule,
                        MatButtonModule,
                        MatDialogModule,
                        MatProgressSpinnerModule,
                        MatSnackBarModule,
                        MatDividerModule,
                        FormsModule,
                        ObserversModule,
                        OverlayModule,
                        NgeMonacoModule.forRoot({ locale: "de", options: { scrollBeyondLastLine: true }, theming: { default: "vs-dark" } })
                    ],
                    declarations: [
                        CapitalizePipe,
                        ConvertToSubjectPipe,
                        CorrectLinksDirective,
                        DiffDisplayComponent,
                        FlattenPipe,
                        HumanizeDurationPipe,
                        ImagePreviewComponent,
                        JsonStringPipe,
                        KeysPipe,
                        LoadingElementDirective,
                        SacAutofocusDirective,
                        SafePipe,
                        ScrollableDirective,
                        SortPipe,
                        SpaceBeforeCapPipe,
                        StringifyPipe,
                        TimezonePipe,
                        UppercaseSpacePipe,
                        UrlConformPipe,
                        ValuesPipe,
                        TranslatePipe,
                        NiceObjectWrapperComponent,
                        HighlightDirective,
                        DecodeUriComponentPipe,
                        NgForTrackByIdDirective,
                        NgForTrackByIndexDirective,
                        NgForTrackByJsonDirective,
                        OverlayComponent,
                        TextReplacerPipe,
                        NonEmptyStringPipe,
                        IsArrayPipe,
                        NonEmptyObjectPipe,
                        RangePipe,
                        MonacoEditorComponent
                    ],
                    providers: [
                        BreakpointService,
                        DataStore,
                        DataTypeStore,
                        ErrorMessageHandler,
                        FrontendTypeRegistry,
                        { provide: SmallstackTypeRegistry, useExisting: FrontendTypeRegistry },
                        RouterUtilService,
                        FrontendSchemaService,
                        ScrollTopService
                    ],
                    exports: [
                        CapitalizePipe,
                        ConvertToSubjectPipe,
                        CorrectLinksDirective,
                        DiffDisplayComponent,
                        FlattenPipe,
                        HumanizeDurationPipe,
                        ImagePreviewComponent,
                        JsonStringPipe,
                        KeysPipe,
                        LoadingElementDirective,
                        SacAutofocusDirective,
                        SafePipe,
                        ScrollableDirective,
                        SortPipe,
                        SpaceBeforeCapPipe,
                        StringifyPipe,
                        TimezonePipe,
                        UppercaseSpacePipe,
                        UrlConformPipe,
                        ValuesPipe,
                        TranslatePipe,
                        NiceObjectWrapperComponent,
                        HighlightDirective,
                        DecodeUriComponentPipe,
                        NgForTrackByIdDirective,
                        NgForTrackByIndexDirective,
                        NgForTrackByJsonDirective,
                        OverlayComponent,
                        TextReplacerPipe,
                        NonEmptyStringPipe,
                        IsArrayPipe,
                        NonEmptyObjectPipe,
                        RangePipe,
                        MonacoEditorComponent
                    ]
                }]
        }] });
